import { useAuth } from "../auth/AuthContext";
import { useLogout } from "../auth/useLogout";
import { Button } from "../design-system";

type AccessDeniedReason = "role" | "launcher" | "admin";

const DENIAL_COPY: Record<
  AccessDeniedReason,
  { title: string; description: string }
> = {
  role: {
    title: "Access required",
    description:
      "This account has no recognized Isara Modeling role. Ask your Isara engagement team for reader, launcher, or admin access.",
  },
  launcher: {
    title: "Build launch access required",
    description:
      "You can review models and builds, but starting a new build requires launcher or admin access.",
  },
  admin: {
    title: "Admin access required",
    description: "This workspace tool is available only to administrators.",
  },
};

export default function AccessDeniedPage({
  reason = "role",
  embedded = false,
}: {
  reason?: AccessDeniedReason;
  embedded?: boolean;
}) {
  const { configured, identity } = useAuth();
  const logout = useLogout();
  const copy = DENIAL_COPY[reason];
  const card = (
    <div className="access-denied__card">
      <div className="page-eyebrow">Access required</div>
      <h1>{copy.title}</h1>
      <p>{copy.description}</p>
      {identity?.email && (
        <p className="muted">Signed in as {identity.email}</p>
      )}
      {configured && reason === "role" && (
        <Button variant="secondary" onClick={logout}>
          Sign out or switch account
        </Button>
      )}
    </div>
  );

  if (embedded) {
    return (
      <section
        className="access-denied access-denied--embedded"
        aria-label={copy.title}
      >
        {card}
      </section>
    );
  }
  return (
    <main className="access-denied" role="main">
      {card}
    </main>
  );
}
